import React, { useState, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import { AppContext } from "../../../context/AppContext";
import "./Css/Login.css";
const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { baseUrl, isLoggedIn, isLoggedInUser, setUserToken, setIsAdminUser } =
    useContext(AppContext);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(`${baseUrl}/login`, {
        username,
        password,
      });
      if (res.data.token) {
        console.log("login", res.data);
        setUserToken(res.data.token);
        isLoggedInUser(true);
        setIsAdminUser(true);
        //navigate("/backbone/gamelist");
      }
      setError("");
    } catch (err) {
      setError("Invalid credentials");
    }
  };

  return (
    <div className="login-container">
      {!isLoggedIn && (
        <div className="login-card">
          <h2>Login</h2>
          {error && <p className="error">{error}</p>}
          <form onSubmit={handleLogin}>
            <div className="form-row">
              <label>Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="form-row">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
            <button type="submit" className="login-btn">
              Login
            </button>
          </form>
        </div>
      )}
      {isLoggedIn && (
        <div className="welcome-card">
          <h2>Welcome, {username}!</h2>
          {/* <p>You are logged in.</p> */}
          <button
            onClick={() => {
              setUserToken(null);
              isLoggedInUser(false);
              setIsAdminUser(false);
            }}
            className="logout-btn"
          >
            Logout
          </button>
        </div>
      )}
    </div>
  );
};

export default Login;
